import statistics2024 from './2024'
import statistics2025 from './2025'

export const statisticsData = {
  2024: statistics2024,
  2025: statistics2025,
}
